import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

// Components
import Image from "../Atoms/Image";
import Paragraph from "../Atoms/Paragraph";

// Stylesheets
import "./ImageWithLabel.scss";

export function ImageWithLabel({
  className,
  label,
  labelClassName,
  description,
  stackedOnDesktop = false,
  lazyLoading = true,
  icon = null,
  ...rest
}) {
  const classes = classNames(
    "image_with_label",
    { stacked_on_desktop: stackedOnDesktop },
    className
  );
  const labelClasses = classNames("image_label", labelClassName);
  const imageProps = {
    ...rest,
    loading: lazyLoading ? "lazy" : null,
  };
  const ImageComponent = icon || Image;

  return (
    <div className={classes}>
      <ImageComponent {...imageProps} />

      <span className={labelClasses}>{label}</span>

      {description ? (
        <Paragraph className="description">{description}</Paragraph>
      ) : null}
    </div>
  );
}

ImageWithLabel.propTypes = {
  className: PropTypes.any,
  labelClassName: PropTypes.any,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  alt: PropTypes.string.isRequired,
  stackedOnDesktop: PropTypes.bool,
  lazyLoading: PropTypes.bool,
};

export default ImageWithLabel;
